module.exports = __webpack_public_path__ + "static/placeholdersNo-563e1114254460e7bc54c6f4802e774f.png";